import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    Input,
    OnDestroy,
    OnInit,
    ViewContainerRef
} from '@angular/core';
import {UploadedFile} from '@interfaces/file.interface';
import {
    ConclusionScanFormModalComponent
} from '@modules/conclusion/components/conclusion-scan-form-modal/conclusion-scan-form-modal.component';
import {take} from 'rxjs/operators';
import {untilDestroyed} from 'ngx-take-until-destroy';

@Component({
    selector: 'app-conclusion-scan-preview',
    templateUrl: './conclusion-scan-preview.component.html',
})
export class ConclusionScanPreviewComponent implements OnInit, OnDestroy {

    @Input() conclusionId: number;

    @Input() scan: UploadedFile;

    private factory: ComponentFactory<ConclusionScanFormModalComponent>;

    private componentRef: ComponentRef<ConclusionScanFormModalComponent>;

    constructor(
        private viewContainer: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
    ) {
    }

    ngOnInit() {
        this.factory = this.resolver.resolveComponentFactory(ConclusionScanFormModalComponent);
    }

    showForm() {
        this.destroyIfExisted();

        this.componentRef = this.viewContainer.createComponent(this.factory);

        this.componentRef.instance.saved.pipe(
            take(1),
            untilDestroyed(this)
        ).subscribe((scan: UploadedFile) => {
            if (scan || scan === null) {
                this.scan = scan;
            }
        });

        this.componentRef.instance.show(this.conclusionId, this.scan);
    }

    ngOnDestroy(): void {
        this.destroyIfExisted();
    }

    private destroyIfExisted() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }
}
